import React from 'react'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import Colors from '../assets/styles/Colors'
import LinkEdingIcon from '../assets/v2/JSX/LinkEdingIcon'
import { useTranslation } from 'react-i18next'
//
//
const TeammateCard: React.FC<{
  imgUrl?: string
  fullName?: string
  position?: string
  description?: string
  linkUrl?: string
}> = ({ imgUrl, fullName, position, description, linkUrl }) => {
  //
  const { t } = useTranslation()
  //
  return (
    <Wrapper>
      <Img src={imgUrl} alt="teammate-img" />
      <FullName>{fullName}</FullName>
      <Position>{position}</Position>

      <Hr />
      {/* <p>{description}</p> */}

      <Link href={linkUrl} target="_blank">
        <LinkEdingIcon />
        <ProfileView>{t('linkedInProfile')}</ProfileView>
      </Link>
    </Wrapper>
  )
}
//
const Link = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`
const ProfileView = styled.span`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-left: 9px;
`
const Hr = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`
const Position = styled.div`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
`
const FullName = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 10px;
`
const Img = styled.img`
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 26px;

  ${Responsive.tablet} {
    width: 136px;
    height: 136px;
  }

  ${Responsive.mobile} {
    width: 136px;
    height: 136px;
  }
`
const Wrapper = styled.div`
  background-color: ${Colors.white};
  border-radius: 8px;
  outline: 1px solid transparent;
  transition: all 300ms ease;
  box-shadow: 0px 1px 12px 1px ${Colors.grey};
  padding-block: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  :hover {
    outline: 1px solid ${Colors.primaryBlack};
    transition: all 300ms ease;
  }
`
//
export default TeammateCard
